import App from './App.svelte';
import { mount } from "svelte";

const app = mount(App, {
	target: document.querySelector('#web-dialogs-app'),
	props: {
	}
});

export default app;